// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.color-button-grid {
  display: grid;
  place-items: center;
  grid-template-columns: repeat(8, 1fr);
  -moz-column-gap: 6px;
       column-gap: 6px;
  row-gap: 6px;
}
section.color-button-grid > div {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 4px;
}
section.color-button-grid .grid-button-wrapper {
  display: grid;
}
section.color-button-grid .grid-button-wrapper > * {
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 1;
}
section.color-button-grid .grid-button-wrapper.circle input,
section.color-button-grid .grid-button-wrapper.circle div.button {
  border-radius: 50%;
}
section.color-button-grid .grid-button-wrapper input {
  cursor: pointer;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 6px;
}
section.color-button-grid .grid-button-wrapper div.button {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 4px;
}
section.color-button-grid .button {
  border-radius: 6px;
  border: 1px solid rgb(240, 240, 240);
  background-color: white;
  display: grid;
  place-items: center;
  color: rgb(110, 110, 110);
}
section.color-button-grid .button-icon {
  width: 1.25rem;
  height: 1.25rem;
}
section.color-button-grid .button-icon path {
  fill: rgb(110, 110, 110);
}
section.color-button-grid .button.circle {
  border-radius: 50%;
}
section.color-button-grid .hex-input-wrapper {
  grid-column: 3/span 4;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ColorPicker/ColorButtonGrid.scss","webpack://./src/Components/Global/ColorPicker/Variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,oBAAA;OAAA,eAAA;EACA,YAAA;AADF;AAGE;EACE,aCVc;EDWd,cCXc;EDYd,kBAAA;AADJ;AAIE;EACE,aAAA;AAFJ;AAII;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAFN;AAMM;;EAEE,kBAAA;AAJR;AAQI;EACE,eAAA;EACA,aClCY;EDmCZ,cCnCY;EDoCZ,kBCnCe;AD6BrB;AASI;EACE,aCxCY;EDyCZ,cCzCY;ED0CZ,kBAAA;AAPN;AAWE;EACE,kBC9CiB;ED+CjB,oCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AATJ;AAWI;EACE,cAAA;EACA,eAAA;AATN;AAWM;EACE,wBAAA;AATR;AAaI;EACE,kBAAA;AAXN;AAeE;EACE,qBAAA;EACA,WAAA;AAbJ","sourcesContent":["@import './Variables.scss';\n\nsection.color-button-grid {\n  display: grid;\n  place-items: center;\n  grid-template-columns: repeat(8, 1fr);\n  column-gap: 6px;\n  row-gap: 6px;\n\n  & > div {\n    width: $colorButtonSize;\n    height: $colorButtonSize;\n    border-radius: 4px;\n  }\n\n  .grid-button-wrapper {\n    display: grid;\n\n    & > * {\n      grid-column-start: 1;\n      grid-column-end: 1;\n      grid-row-start: 1;\n      grid-row-end: 1;\n    }\n\n    &.circle {\n      input,\n      div.button {\n        border-radius: 50%;\n      }\n    }\n\n    input {\n      cursor: pointer;\n      width: $colorButtonSize;\n      height: $colorButtonSize;\n      border-radius: $buttonBorderRadius;\n    }\n\n    div.button {\n      width: $colorButtonSize;\n      height: $colorButtonSize;\n      border-radius: 4px;\n    }\n  }\n\n  .button {\n    border-radius: $buttonBorderRadius;\n    border: 1px solid rgb(240, 240, 240);\n    background-color: white;\n    display: grid;\n    place-items: center;\n    color: rgb(110, 110, 110);\n\n    &-icon {\n      width: 1.25rem;\n      height: 1.25rem;\n\n      path {\n        fill: rgb(110, 110, 110);\n      }\n    }\n\n    &.circle {\n      border-radius: 50%;\n    }\n  }\n\n  .hex-input-wrapper {\n    grid-column: 3 / span 4;\n    width: 100%;\n  }\n}\n","$colorButtonSize: 2.5rem;\n$buttonBorderRadius: 6px;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
